import React, { useEffect, useRef } from 'react';
import '../stylesheets/components/StepPopup.css';
import PropTypes from 'prop-types';

export default function StepPopup({ step, onClose }) {
  const popupRef = useRef(null);

  // Disable scrolling when modal is open
  useEffect(() => {
    if (!step) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [step]);

  // Handle outside clicks
  const handleClickOutside = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      onClose();
    }
  };

  if (!step) return null;

  return (
    <div
      className="popup-overlay"
      role="button"
      tabIndex={0}
      onClick={handleClickOutside}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClickOutside(e);
        }
      }}
    >
      <div className="popup-content" ref={popupRef}>
        <div style={{ position: 'relative', padding: '0 24px 0 24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', minHeight: 56, borderBottom: '1px solid #e5e5e5', padding: '16px 0' }}>
            <div style={{ flex: 1, textAlign: 'center', fontWeight: 700, fontSize: 20 }}>
              Step {step.number}. {step.title}
            </div>
            <button
              type="button"
              aria-label="Close"
              onClick={onClose}
              style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', lineHeight: 1 }}
            >
              &times;
            </button>
          </div>
          <div style={{ padding: '10px 0', textAlign: 'center' }}>
            <p className="popup-description">{step.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

StepPopup.propTypes = {
  step: PropTypes.shape({
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
};